// src/pages/Products.js
import React from "react";

// Import images
import products1 from "../assets/products1.webp";
import products2 from "../assets/products2.webp";
import products3 from "../assets/products3.webp";

// 🔹 Reusable Section Component
const SectionWithImages = ({
  id,
  title,
  text,
  images,
  reverse = false,
  labels = [],
  titleClassName = "",
}) => {
  return (
    <div
      id={id}
      className={`flex flex-col ${
        reverse ? "sm:flex-row-reverse" : "sm:flex-row"
      } items-center text-white bg-gray-900 p-12 sm:p-20 gap-8`}
    >
      {/* Text Section */}
      <div
        className={`w-full ${
          images.length === 0 ? "text-center" : "sm:w-1/2 text-left"
        }`}
      >
        <h2
          className={`text-4xl sm:text-5xl font-bold mb-6 animate-fadeIn ${titleClassName}`}
        >
          {title}
        </h2>
        <p className="text-lg sm:text-xl animate-fadeIn animate-delay-300 text-justify whitespace-pre-line">
          {text || ""}
        </p>
      </div>

      {/* Images Section */}
      {images.length > 0 && (
        <div
          className={`w-full sm:w-1/2 grid grid-cols-1 ${
            images.length > 1 ? "sm:grid-cols-2" : ""
          } gap-4`}
        >
          {images.map((img, index) => (
            <div key={index} className="flex flex-col items-center">
              <img
                src={img}
                alt={`${title} ${labels[index] || "Image"}`}
                className="rounded-lg shadow-lg transform hover:scale-105 transition duration-300 w-full h-64 sm:h-80 object-cover"
              />
              {labels[index] && (
                <p className="mt-2 text-sm sm:text-base text-gray-300 text-center">
                  {labels[index]}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const Products = () => {
  return (
    <div className="w-full">
      {/* 🔹 Our Products */}
      <SectionWithImages
        id="our-products"
        title="Our Products"
        text="Our products are designed to present microalgae solutions, with high quality standards to the most demanding markets, focusing on dietary supplements, food, cosmetics feed and agro applications. The microalgae products currently being valued in sectors such as agriculture, nutrition, cosmetic and aquaculture. Their immense potential is currently being studied for application in pharmacology, in the production of biomaterials and in the energy sector, as precursors of fourth-generation biofuels."
        images={[]}
        reverse={false}
      />

      {/* 🔹 food-supplements Section */}
      <SectionWithImages
        id="food-supplements"
        title="Food Supplements and Nutraceuticals:"
        text=""
        images={[]}
        reverse={false}
      />

      {/* 🔹 Spirulina Powder Section */}
      <SectionWithImages
        id="spirulina-powder"
        title="Spirulina Powder:"
        text={`Cultivation Method: Closed raceway ponds / tubular photobioreactors\nProducts: Slurry, powder, tablets`}
        images={[products1]}
        labels={["Spirulina Powder"]}
        reverse={true}
        titleClassName="text-2xl sm:text-3xl lg:text-4xl"
      />

      {/* 🔹 Beta – carotene Section */}
      <SectionWithImages
        id="beta-carotene"
        title={
          <span>
            Beta – carotene from <em>Dunaliella salina</em>:
          </span>
        }
        text={`Cultivation Method: Tubular photobioreactors /  Closed raceway pond.\nProducts: Slurry, powder, tablets.\nIn future we aim to extract beta – carotene and omega 3 fatty acid as well.`}
        images={[products2]}
        labels={["Beta – carotene from Dunaliella salina"]}
        reverse={false}
        titleClassName="text-2xl sm:text-3xl lg:text-4xl"
      />

      {/* 🔹 Astaxanthin Section */}
      <SectionWithImages
        id="astaxanthin"
        title={
          <span>
            Astaxanthin from <em>Haematococcus pluvialis</em>
          </span>
        }
        text={`Cultivation Method: Tubular photobioreactors /  Closed raceway pond.\nProducts: Slurry, powder, tablets.\nIn future we aim to extract astaxanthin as well.`}
        images={[products3]}
        labels={["Astaxanthin from Haematococcus pluvialis"]}
        reverse={true}
        titleClassName="text-2xl sm:text-3xl lg:text-4xl"
      />
    </div>
  );
};

export default Products;
